module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-Book-WebM-88e1b22a3ffc348dfab2e82ac9e18647.woff2";